document.addEventListener('focusin', (e) => {
    if (!e.target.matches('input, textarea, select') || !e.target.closest('.page-content--product')) return;

    e.target.style.opacity = 0;
    setTimeout(() => {
        e.target.style.opacity = 1
    }, 100);
});

document.addEventListener('click', function (event) {
    const target = event.target;

    if (target.tagName === 'A' && target.getAttribute('href')) {
        if (target.getAttribute('href').startsWith('#')) {
            const targetID = target.getAttribute('href').replace("#", "");
            const targetElement = document.getElementById(targetID);

            if (targetElement) {
                event.preventDefault();

                window.scrollTo({
                    top: targetElement.offsetTop - 50,
                    behavior: 'smooth'
                });
            }
        }
    }
});
